// extracted by mini-css-extract-plugin
export var circle = "_cr-1";
export var exitConfirmationModal = "_cr-5";
export var iframe = "_cr-0";
export var offline = "_cr-3";
export var online = "_cr-2";
export var workstationSelectError = "_cr-4";